// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"633":"d69aa6c6","749":"073e9f55","903":"006587f4"}[chunkId] + ".chunk.js";
};